import { eventBus } from '../events/EventBus';
import { getSession } from '../api/authApi';
export const AUTH_CHANGED_EVENT = 'auth:changed';
class AuthService {
    constructor() {
        Object.defineProperty(this, "authorized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "initPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    async initialize() {
        if (!this.initPromise) {
            this.initPromise = this.loadSession();
        }
        return this.initPromise;
    }
    async loadSession() {
        try {
            const session = await getSession();
            this.authorized = session.authorized;
            this.user = session.user ?? null;
        }
        catch (error) {
            console.error('Failed to load session:', error);
            this.authorized = false;
            this.user = null;
            // Let a future call retry instead of permanently caching a failure.
            this.initPromise = null;
        }
    }
    get isAuthorized() {
        return this.authorized;
    }
    get currentUser() {
        return this.user;
    }
    setAuthenticated(user) {
        this.authorized = true;
        this.user = user;
        eventBus.emit(AUTH_CHANGED_EVENT, { authorized: true, user });
    }
    clear() {
        this.authorized = false;
        this.user = null;
        eventBus.emit(AUTH_CHANGED_EVENT, { authorized: false, user: null });
    }
}
export const authService = new AuthService();
